import { lockHasDescriptor } from './lockHasDescriptor';
import type { ItemCacheLockId } from '../store/schema/ItemCacheLockId';
import { orFilters } from '../utils/filter/combineFilters';
import type { ItemCache } from '../store/schema/ItemCache';
import type { CacheItem } from '../store/schema/CacheItem';
import type { CacheDescriptor } from '../store/schema/CacheDescriptor';

export function getItemsForLock<T extends CacheItem, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    lockId: ItemCacheLockId,
    itemDescriptor: U,
    buildDescriptorFilter: (descriptor: U) => (item: T) => boolean,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): T[] | undefined {
    if (!lockHasDescriptor(store, lockId, itemDescriptor, containsDescriptor)) {
        return undefined;
    }
    const filterItems = buildDescriptorFilter(itemDescriptor);

    return [...store.items.values()].filter(filterItems);
}

// TODO VSO 64240: Optimize getAllItemsForLock by using computedFn from mobx utils
export function getAllItemsForLock<T extends CacheItem, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    lockId: ItemCacheLockId,
    buildDescriptorFilter: (descriptor: U) => (item: T) => boolean
): T[] | undefined {
    const lockDescriptorIds = store.locks.get(lockId);
    if (!lockDescriptorIds) {
        return undefined;
    }
    const descriptors = lockDescriptorIds.reduce((values: U[], id: string) => {
        const descriptor = store.descriptors.get(id);
        if (descriptor) {
            values.push(descriptor);
        }
        return values;
    }, []);
    const filterItems = orFilters(descriptors.map(buildDescriptorFilter));

    return [...store.items.values()].filter(filterItems);
}
